import { render, staticRenderFns } from "./TraysMassive.vue?vue&type=template&id=41548ece&"
import script from "./TraysMassive.vue?vue&type=script&lang=js&"
export * from "./TraysMassive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41548ece')) {
      api.createRecord('41548ece', component.options)
    } else {
      api.reload('41548ece', component.options)
    }
    module.hot.accept("./TraysMassive.vue?vue&type=template&id=41548ece&", function () {
      api.rerender('41548ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/TraysMassive.vue"
export default component.exports